import { Component } from 'opus-angular-seed-core';
import { xIcon } from '../fileIcon';
@Component({
    bindings: {
        entityType: '<',
        entityId: '<',
        courseId: '<'
    },
    template: `
        <div class="heading01">
            <h3>{{ 'file.Additional materials' | translate }}</h3>
        </div>
        <div class="colholder w100p">
            <div class="col col01">
                <file-file-upload
                    on-file-uploaded="vm.onFileUploaded(file)"
                    max-files="15"
                    current-file-count="vm.files.length"
                    uploading-files="vm.uploadingFiles"
                    attach-to-entities="vm.attachEntities"
                    existing-files="vm.files">
                </file-file-upload>
            </div>
            <div class="col col01">
                <button class="browse" ng-click="vm.openFileLibrary()">
                    <span class="browse__inner">
                        <span class="title">{{ 'file.Browse file library' | translate }} <small>{{ 'file.Select from uploaded files' | translate }}</small></span>
                        <!-- span>{{ 'file.Search and filter existing files' | translate }}</span -->
                        <span class="btn">
                            {{ 'file.Open file library' | translate }}
                        </span>
                    </span>
                </button>
            </div>
        </div>
        <div class="dropzone" ng-if="vm.uploadingFiles.length">
            <div class="dropzone-item" ng-repeat="item in vm.uploadingFiles">
                <file-file-icon filename="item.name" size="lg"></file-file-icon>
                <div class="dropzone-item__inner">
                    <div class="dropzone-item__title">
                        <p>{{ item.name }}</p>
                        <a ng-click="vm.removeUploadItem(item)" style="cursor:pointer;"><span class="file-icon file-icon--sm" ng-bind-html="vm.xIconHtml"></span></a>
                    </div>
                    <p class="dropzone-item__meta">{{ vm.formatFileSize(item.size) }}</p>
                    <div class="dropzone-item__progress" ng-if="!item.error && item.progress < 100">
                        <span ng-style="{ width: item.progress + '%' }">{{ item.progress }}%</span>
                    </div>
                    <p class="dropzone-item__meta text-danger" ng-if="item.error">{{ item.error }}</p>
                </div>
            </div>
        </div>
        <file-file-list
            files="vm.files"
            entity-type="vm.entityType"
            entity-id="vm.entityId"
            on-file-detached="vm.loadFiles()">
        </file-file-list>
    `
})
export default class {
    constructor (FileService, ModalService, toastr, $translate, $q, $sce) {
        this.FileService = FileService;
        this.xIconHtml = $sce.trustAsHtml(xIcon);
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.$translate = $translate;
        this.$q = $q;
        this.files = [];
        this.uploadingFiles = [];
    }
    $onInit () {
        this._updateAttachEntities();
        this.loadFiles();
    }
    $onChanges (changes) {
        if (changes.entityId && !changes.entityId.isFirstChange()) {
            this._updateAttachEntities();
            this.loadFiles();
        }
    }
    loadFiles () {
        if (!this.entityType || !this.entityId) {
            return;
        }
        this.FileService.getEntityFiles(this.entityType, this.entityId).then((files) => {
            this.files = files;
        });
    }
    _updateAttachEntities () {
        const entities = [{ entityType: this.entityType, entityId: this.entityId }];
        if (this.courseId) {
            entities.push({ entityType: 'course', entityId: this.courseId });
        }
        this.attachEntities = entities;
    }
    onFileUploaded (file) {
        if (!file || !file.hash) {
            return;
        }
        this.toastr.success(this.$translate.instant('file.File uploaded successfully'));
        this.loadFiles();
    }
    removeUploadItem (item) {
        const index = this.uploadingFiles.indexOf(item);
        if (index > -1) {
            this.uploadingFiles.splice(index, 1);
        }
    }
    formatFileSize (bytes) {
        if (!bytes) {
            return '0 KB';
        }
        if (bytes < 1024) {
            return `${bytes} B`;
        }
        if (bytes < 1024 * 1024) {
            return `${(bytes / 1024).toFixed(2)} KB`;
        }
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    }
    openFileLibrary () {
        const { entityType, entityId, courseId } = this;
        this.ModalService.open({
            template: `
                <file-file-library-modal
                    resolve="vm.resolve"
                    modal-instance="vm.$uibModalInstance">
                </file-file-library-modal>`,
            controller ($uibModalInstance) {
                this.resolve = { entityType, entityId, courseId };
                this.$uibModalInstance = $uibModalInstance;
            },
            size: 'xlarge'
        }).then(() => {
            this.loadFiles();
        }).catch(() => {
            this.loadFiles();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/file/fileManager/index.js